import React from 'react';
import { Link } from 'react-router-dom';
import SearchBar from "../../Components/SearchBar";
import Avatar from "../../Components/Avatar";

const DevLandingHeader = () => {
    return (
        <header className="my-6 lg:my-10 space-y-8">
            <div className="flex justify-between items-center lg:justify-end">
                <a className="text-white border-2 border-white rounded-lg aspect-square w-10 flex place-content-center place-items-center lg:hidden" href="#">
                    <i className="ri-search-line"></i>
                </a>
                <img className="w-32 inline-block" src="https://www.kipmate.com/sortyourkip/client/build/kmlogo.svg" alt="KipMate Logo"/>
            </div>
            <div className="flex justify-between items-center">
                <h1 className="text-5xl lg:text-6xl font-semibold text-white">Let's Get Started</h1>

                <div className="hidden lg:flex items-center space-x-6">


                    <SearchBar />

                    <div>
                        <Avatar width={"w-12"} height={"h-12"} />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default DevLandingHeader;